import { ReactComponent as GiftIcon } from '@/assets/images/svg/gift.svg';
import Button from '@/components/Button';
import CreateLazbubu from '@/components/CreateLazbubu';
import user from '@/stores/user';

import { TYPE } from '@/theme';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
// Styled Components
const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
`;

// Flip Card Container
const FlipCardContainer = styled.div`
    perspective: 1000px;
    width: 100%;
    max-width: 400px;
    height: 600px;
    position: relative;
`;

const FlipCardInner = styled.div<{ $isFlipped: boolean }>`
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;
    transform: ${({ $isFlipped }) =>
        $isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'};
`;

const FlipCardFace = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 24px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const FlipCardFront = styled(FlipCardFace)`
    background: transparent;
`;

const FlipCardBack = styled(FlipCardFace)`
    background: transparent;
    transform: rotateY(180deg);
    overflow-y: auto;
`;

const ContentWrapper = styled.div`
    border-radius: 24px;
    padding: 3rem;
    max-width: 400px;
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

const Title = styled(Typography)`
    font-size: 20px;
    color: #000;
    font-weight: 600;
`;

const BoxImageContainer = styled.div`
    border-radius: 20px;
    padding: 2rem;
    margin-bottom: 1.5rem;
    position: relative;
    overflow: hidden;
`;

const BoxImage = styled.img`
    width: 100%;
    width: 240px;
    height: auto;
    object-fit: contain;
    border-radius: 32px;
`;

const RarityText = styled(Typography)`
    font-size: 14px;
    color: #000;
    margin-bottom: 1.5rem;
`;

const PageButton = styled(Button)`
    width: 160px !important;
`;

const NoResultWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    svg {
        color: rgba(207, 223, 249, 1);
        width: 64px;
        height: 64px;
    }
`;

const Gift: React.FC = observer(() => {
    const history = useHistory();

    const [isFlipped, setIsFlipped] = useState(false);

    const handleOpenBox = () => {
        // Generate a random ID for the new Lazbubu

        setIsFlipped(true);
    };

    if (user.hasGift)
        return (
            <PageContainer>
                <FlipCardContainer>
                    <FlipCardInner $isFlipped={isFlipped}>
                        <FlipCardFront>
                            <ContentWrapper>
                                <Title>Open your gift</Title>

                                <BoxImageContainer>
                                    <BoxImage
                                        src={require('@/assets/images/gift.png')}
                                        alt="Lazbubu gift Box"
                                    />
                                </BoxImageContainer>

                                {!!user.userLazbubuInfo?.giftLazbubuCreated ? (
                                    <PageButton size="small" disabled>
                                        Gift minted
                                    </PageButton>
                                ) : (
                                    <PageButton
                                        size="small"
                                        onClick={handleOpenBox}
                                    >
                                        Open gift
                                    </PageButton>
                                )}
                            </ContentWrapper>
                        </FlipCardFront>

                        <FlipCardBack>
                            <CreateLazbubu
                                lazbubuData={
                                    user.userLazbubuInfo?.giftLazbubuData || ''
                                }
                                onCreateSuccess={() => {
                                    user.getLazbubuData();
                                }}
                                refetchLazbubuData={user.getLazbubuData}
                            />
                        </FlipCardBack>
                    </FlipCardInner>
                </FlipCardContainer>
            </PageContainer>
        );

    return (
        <PageContainer>
            <ContentWrapper>
                <NoResultWrapper>
                    <GiftIcon />
                    <TYPE.main
                        fontSize={14}
                        marginTop={'2rem'}
                        fontWeight={600}
                    >
                        {!user.hasGift
                            ? ' No gift yet'
                            : !!user.userLazbubuInfo?.giftLazbubuCreated
                            ? 'Your gift is already opened.'
                            : null}
                    </TYPE.main>
                </NoResultWrapper>
            </ContentWrapper>
        </PageContainer>
    );
});

export default Gift;
